import { Modal, TextTitle, Stack, Spacer } from '@pypestream/design-system';
import { FC } from 'react';

import { ProductCTA } from '../../product-cta';
import { ManagerContext } from '../../../xstate/manager.xstate.types';
import { ProductName } from '@pypestream/api-services';
import { useTranslation } from '@pypestream/translations';
import { useReleasedTools } from '../../../hooks';

interface ProductCardsModalProps {
  open: boolean;
  project?: NonNullable<ManagerContext['projectsNew']>[number];
  onClose: () => void;
}

export const ProductCardsModal: FC<ProductCardsModalProps> = ({
  open,
  project,
  onClose,
}) => {
  const releasedProducts = useReleasedTools(project?.conditionalProducts);
  const [t] = useTranslation();

  return (
    <Modal open={open} size="large" onClose={onClose}>
      <div slot="header">
        <Spacer size="medium"></Spacer>
        <TextTitle slot="header" size="xsmall" textAlign="center">
          {t('manager/common:products.selectToolToView', {
            projectName: project?.name || '',
          })}
        </TextTitle>
      </div>
      <Spacer size="medium"></Spacer>
      <div className="c-tools-grid">
        {releasedProducts
          ?.filter(
            ({ name }: { name: ProductName | 'Studio' }) => name !== 'Studio'
          )
          .map(({ url, logo, label, productId, disabled }, index) => {
            return (
              <ProductCTA
                url={url}
                logo={logo}
                name={label}
                key={productId || index}
                disabled={disabled}
                // style={{ maxWidth: 146 }}
              />
            );
          })}
      </div>
      <Spacer size="medium"></Spacer>
    </Modal>
  );
};
